/* ASAKA — Kaching Cart additions (free shipping banner, savings summary, ships-by date, reassurance, Trustpilot).
   Kaching renders with Svelte: we only add sibling nodes and attributes, never touch its own nodes,
   and re-sync whenever it re-renders. */
(() => {
  if (window.__asakaCart) return;
  window.__asakaCart = true;
  const TP_IMG = (document.currentScript && document.currentScript.dataset.tpImg) || '';
  const SHIP_IMG = (document.currentScript && document.currentScript.dataset.shipImg) || '';

  const ICON = {
    truck: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M2 6h11v10H2zM13 9h4l4 4v3h-8z"/><circle cx="6" cy="17.5" r="1.8"/><circle cx="17" cy="17.5" r="1.8"/></svg>',
    check: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>',
    tag: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20.6 13.4l-7.2 7.2a2 2 0 0 1-2.8 0L3 13V3h10l7.6 7.6a2 2 0 0 1 0 2.8z"/><circle cx="7.5" cy="7.5" r="1.4"/></svg>',
    returns: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 14L4 9l5-5"/><path d="M4 9h10.5a5.5 5.5 0 0 1 0 11H11"/></svg>',
    shield: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 3l7 2.8v5.4c0 4.4-3 8.2-7 9.8-4-1.6-7-5.4-7-9.8V5.8z"/><path d="M9 12l2.2 2.2L15 10.4"/></svg>'
  };

  const SAVE_HTML = ICON.tag + '<span>You save <strong data-save></strong></span>';
  const ASSURE_HTML =
    '<p class="ak-kc-assure__trust">' +
      '<span class="ak-kc-trust">' + ICON.truck + 'Free Shipping</span>' +
      '<span class="ak-kc-trust">' + ICON.returns + '60-Day Trial</span>' +
      '<span class="ak-kc-trust">' + ICON.shield + 'Lifetime Warranty</span></p>' +
    (TP_IMG ? '<img class="ak-kc-assure__tp" src="' + TP_IMG + '" alt="Rated Excellent, 4.8 out of 5 on Trustpilot" width="1200" height="80" loading="lazy">' : '');
  const SHIPBY_HTML = 'Ships by <strong data-shipby></strong>';

  /* Tomorrow's date in the UK, e.g. "Sat 24 Oct", whatever the shopper's own time zone. */
  const ukParts = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', year: 'numeric', month: 'numeric', day: 'numeric' });
  const shortDate = new Intl.DateTimeFormat('en-GB', { timeZone: 'UTC', weekday: 'short', day: 'numeric', month: 'short' });
  const ukTomorrow = () => {
    const p = ukParts.formatToParts(new Date());
    const g = (t) => parseInt(p.find((x) => x.type === t).value, 10);
    return shortDate.format(new Date(Date.UTC(g('year'), g('month') - 1, g('day') + 1, 12))).replace(',', '');
  };

  const money = new Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'GBP'
  });
  const parse = (el) => {
    if (!el) return 0;
    const n = parseFloat(el.textContent.replace(/[^\d.]/g, ''));
    return isNaN(n) ? 0 : n;
  };
  const setText = (el, text) => { if (el && el.textContent !== text) el.textContent = text; };

  /* Shipping is free on every order, so the bar is always complete: it celebrates the reward. */
  const SHIP_HTML =
    (SHIP_IMG ? '<img class="ak-kc-ship__img" src="' + SHIP_IMG + '" alt="" width="192" height="192">'
              : '<span class="ak-kc-ship__img ak-kc-ship__img--icon">' + ICON.truck + '</span>') +
    '<div class="ak-kc-ship__body">' +
      '<div class="ak-kc-ship__head">' +
        '<p class="ak-kc-ship__title"><span>You’ve unlocked</span><strong>Free Premium Shipping</strong></p>' +
        '<p class="ak-kc-ship__price"><s>' + money.format(4.95) + '</s><b>FREE</b></p>' +
      '</div>' +
      '<div class="ak-kc-ship__bar" aria-hidden="true"><span></span><i>' + ICON.check + '</i></div>' +
    '</div>';
  const cartShips = () => {
    const data = window.kachingCartApi && kachingCartApi.getCartData && kachingCartApi.getCartData();
    return !(data && typeof data.then !== 'function' && data.requires_shipping === false);
  };

  /* Create once, and move back into position if Kaching re-created its neighbouring node. */
  const ensure = (cls, html, isPlaced, place) => {
    let el = document.querySelector('#kaching-cart .' + cls);
    if (!el) {
      el = document.createElement('div');
      el.className = cls;
      el.innerHTML = html;
    }
    if (!el.isConnected || !isPlaced(el)) place(el);
    return el;
  };
  const drop = (cls) => { const el = document.querySelector('#kaching-cart .' + cls); if (el) el.remove(); };

  function sync() {
    const root = document.querySelector('#kaching-cart');
    if (!root) return;

    const heading = root.querySelector('.kaching-cart__heading');
    if (heading) {
      const count = (heading.textContent.match(/\d+/) || ['0'])[0];
      if (heading.dataset.akCount !== count) heading.dataset.akCount = count;
      const label = count + (count === '1' ? ' item' : ' items');
      if (heading.dataset.akLabel !== label) heading.dataset.akLabel = label;
    }

    const items = root.querySelectorAll('.kaching-cart-item');
    const contents = root.querySelector('.kaching-cart__contents');
    if (!items.length || !contents) {
      ['ak-kc-ship', 'ak-kc-save', 'ak-kc-shipby', 'ak-kc-assure'].forEach(drop);
      return;
    }

    const timer = contents.querySelector('.kaching-cart__announcement-bar');
    const anchor = timer ? timer.closest('.kaching-cart__module') : null;
    const ship = ensure('ak-kc-ship', SHIP_HTML,
      (el) => (anchor ? el.previousElementSibling === anchor : el === contents.firstElementChild),
      (el) => (anchor ? anchor.after(el) : contents.prepend(el)));
    const hide = !cartShips();
    if (ship.hidden !== hide) ship.hidden = hide;

    const footer = root.querySelector('.kaching-cart__footer');
    const subtotal = footer && footer.querySelector('.kaching-cart__subtotal');
    const button = footer && footer.querySelector('.kaching-cart__checkout-button');
    if (!subtotal || !button) return;

    const total = parse(subtotal.querySelector('span'));
    const label = button.querySelector('.kaching-cart__checkout-button-label');
    if (label && total > 0) {
      const price = money.format(total);
      if (label.dataset.akPrice !== price) label.dataset.akPrice = price;
    }
    let before = 0;
    items.forEach((item) => {
      const old = item.querySelector('.kaching-cart-item__total-old');
      before += parse(old || item.querySelector('.kaching-cart-item__total-final'));
    });
    const saving = Math.max(0, Math.round((before - total) * 100) / 100);

    const save = ensure('ak-kc-save', SAVE_HTML,
      (el) => el.previousElementSibling === subtotal, (el) => subtotal.after(el));
    if (save.hidden !== (saving <= 0)) save.hidden = saving <= 0;
    setText(save.querySelector('[data-save]'), money.format(saving));

    const shipBy = ensure('ak-kc-shipby', SHIPBY_HTML,
      (el) => el.nextElementSibling === button, (el) => button.before(el));
    setText(shipBy.querySelector('[data-shipby]'), ukTomorrow());

    ensure('ak-kc-assure', ASSURE_HTML,
      (el) => el.previousElementSibling === button, (el) => button.after(el));
  }

  /* sync() only writes when something differs, so its own mutations settle after one extra pass. */
  const watch = (root) => {
    new MutationObserver(sync).observe(root, { childList: true, subtree: true, characterData: true });
    sync();
  };

  const existing = document.querySelector('#kaching-cart');
  if (existing) {
    watch(existing);
  } else {
    const finder = new MutationObserver(() => {
      const root = document.querySelector('#kaching-cart');
      if (!root) return;
      finder.disconnect();
      watch(root);
    });
    finder.observe(document.documentElement, { childList: true, subtree: true });
  }
})();
